<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x" [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu"></div>
<mat-menu class="avmup-menu" #contextMenu="matMenu">
	@for (menuItem of contextMenuItems; track menuItem; let i = $index) {
		<a class="avmup-menu-item" (click)="onContextMenuClick($event, menuItem)">
			<span>{{ menuItem.menuText }}</span>
		</a>
	}
</mat-menu>
